module.exports = "/packs/images/homepage/facilities/covid_information~5f8e605e0056f6d1d3542eff262053df.jpg";